module.exports = __webpack_public_path__ + "media/post-listing-block-6-image-step2@2x.a0f28d6e.webp";